export const materials = [
  {
    img1: "./img/materials-1.png",
    img2: "./img/materials-1@2x.png",
    imgDesk1: "img/materials-1-desktop.png",
    imgDesk2: "./img/materials-1-desktop@2x.png 2x",
    manufacturer1: "./img/veka.png",
    manufacturer2: "./img/veka@2x.png 2x",
    manufacturerDesk1: "img/veka-desktop.png",
    manufacturerDesk2: "./img/veka-desktop@2x.png 2x",
    width: "109",
    height: "120"
  },

  {
    img1: "./img/materials-2.png",
    img2: "./img/materials-2@2x.png",
    imgDesk1: "img/materials-2-desktop.png",
    imgDesk2: "./img/materials-2-desktop@2x.png 2x",
    manufacturer1: "./img/rehau.png",
    manufacturer2: "./img/rehau@2x.png 2x",
    manufacturerDesk1: "img/rehau-desktop.png",
    manufacturerDesk2: "./img/rehau-desktop@2x.png 2x",
    width: "113",
    height: "35"
  },
  {
    img1: "./img/materials-3.png",
    img2: "./img/materials-3@2x.png",
    imgDesk1: "img/materials-3-desktop.png",
    imgDesk2: "./img/materials-3-desktop@2x.png 2x",
    manufacturer1: "./img/proplex.png",
    manufacturer2: "./img/proplex@2x.png 2x",
    manufacturerDesk1: "img/proplex-desktop.png",
    manufacturerDesk2: "./img/proplex-desktop@2x.png 2x",
    width: "91.81",
    height: "71"
  },
  {
    img1: "./img/materials-4.png",
    img2: "./img/materials-4@2x.png",
    imgDesk1: "img/materials-4-desktop.png",
    imgDesk2: "./img/materials-4-desktop@2x.png 2x",
    manufacturer1: "./img/krauss.png",
    manufacturer2: "./img/krauss@2x.png 2x",
    manufacturerDesk1: "img/krauss-desktop.png",
    manufacturerDesk2: "./img/krauss-desktop@2x.png 2x",
    width: "112.9",
    height: "35"
  }

];

export const wood = [
  {
    title: "Золотой дуб",
    color: "img/material-color-1.jpg"
  },
  {
    title: "Орех",
    color: "img/material-color-2.jpg"
  },
  {
    title: "Темный дуб",
    color: "img/material-color-3.jpg"
  }, {
    title: "Горная сосна",
    color: "img/material-color-4.jpg"
  },
  {
    title: "Светлый дуб",
    color: "img/material-color-5.jpg"
  },
  {
    title: "Мореный ду",
    color: "img/material-color-6.jpg"
  },
  {
    title: "Дуглас",
    color: "img/material-color-7.jpg"
  }, {
    title: "Орегон",
    color: "img/material-color-8.jpg"
  },
  {
    title: "Черная вишня",
    color: "img/material-color-9.jpg"
  },
  {
    title: "Махагон",
    color: "img/material-color-10.jpg"
  }, {
    title: "Рустик",
    color: "img/material-color-11.jpg"
  },
  {
    title: "Макоре",
    color: "img/material-color-12.jpg"
  },
  {
    title: "Зимний дуглас",
    color: "img/material-color-13.jpg"
  },
  {
    title: "Обычный дуб",
    color: "img/material-color-14.jpg"
  }, {
    title: "Рустикальный дуб",
    color: "img/material-color-15.jpg"
  },
];

export const usual = [
  {
    title: "Кремовый",
    color: "img/material-color-16.jpg"
  },
  {
    title: "Красный",
    color: "img/material-color-17.jpg"
  },
  {
    title: "Светло-красный",
    color: "img/material-color-18.jpg"
  }, {
    title: "Темно-коричневый",
    color: "img/material-color-19.jpg"
  },
  {
    title: "Вишнево-красный",
    color: "img/material-color-20.jpg"
  },
  {
    title: "Светло-синий",
    color: "img/material-color-21.jpg"
  },
  {
    title: "Синий",
    color: "img/material-color-22.jpg"
  }, {
    title: "Светло-зеленый",
    color: "img/material-color-23.jpg"
  },
  {
    title: "Зеленый",
    color: "img/material-color-24.jpg"
  },
  {
    title: "Серый",
    color: "img/material-color-25.jpg"
  }, {
    title: "Бледно-серый",
    color: "img/material-color-26.jpg"
  },
  {
    title: "Антрацит",
    color: "img/material-color-27.jpg"
  },
  {
    title: "Коричневый",
    color: "img/material-color-28.jpg"
  },
  {
    title: "Серебро",
    color: "img/material-color-29.jpg"
  }, {
    title: "Черный",
    color: "img/material-color-30.jpg"
  },
];